<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .admin-list {
    display: flex;
    flex-direction: column;
    flex: 1 1 0%;
    gap: utils.in_rem(5px);
    min-height: 0;

    .admin-list-title {
      @include mixins.body2();
    }

    .admin-list-items {
      overflow: auto;
      display: flex;
      flex-direction: column;
      flex: 1 1 0%;
      gap: utils.in_rem(5px);
      min-height: 0;

      .admin-item {
        display: flex;
        gap: utils.in_rem(8px);
        align-items: center;

        .admin-name {
          @include mixins.body2();
          @include colors.color(black_90);
        }
      }
    }
  }
</style>

<script>
  import { usersStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import Avatar from "@sourcewhale/shared/svelte-design-system/components/atoms/Avatar.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  import { adminsStore } from "../../../../api-stores/meetings-store";

  usersStore.once();
  let admins = $derived($adminsStore);

  let { selectedAdmins = $bindable([]) } = $props();

  const onClickCheckbox = (admin) => {
    selectedAdmins = selectedAdmins.includes(admin.userId)
      ? selectedAdmins.filter((uid) => uid !== admin.userId)
      : [...selectedAdmins, admin.userId];
  };
</script>

{#if admins.length > 1}
  <div class="admin-list">
    <span class="admin-list-title">Select which admins to notify</span>
    <div class="admin-list-items">
      {#each admins as admin}
        <ListItem
          selected={selectedAdmins.includes(admin.userId)}
          onclick={() => onClickCheckbox(admin)}
          showCheckbox
          checkboxSide="left"
        >
          <div class="admin-item">
            {#if admin.picture && !admin.picture.endsWith(".svg")}
              <Avatar src={admin.picture} size="small" />
            {:else}
              <Avatar
                firstName={admin.firstName || admin.name.split(" ")[0] || ""}
                lastName={admin.lastName || admin.name.split(" ")[1] || ""}
                size="small"
              />
            {/if}
            <span class="admin-name">{admin.name}</span>
          </div>
        </ListItem>
      {/each}
    </div>
  </div>
{/if}
